<div class="add-festival-container">
    <h2>{{ 'festival.addTitle' | translate }}</h2>
    <div class="festival-form-container">
        <form [formGroup]="addFestival" (ngSubmit)="onSave()">
            <div class="festival-form-input">
                <label for="add-festival-name">{{ 'festival.field.name' | translate }}:</label>
                <input formControlName="festivalName" id="add-festival-name" name="add-festival-name" type="text" />
            </div>
            <div class="festival-form-input">
                <label for="add-festival-comment">{{ 'festival.field.comment' | translate }}:</label>
                <textarea id="add-festival-comment" name="add-festival-comment" rows="4" cols="50" formControlName="comment"></textarea>
            </div>
            <div class="festival-form-input">
                <label for="add-festival-start-date">{{ 'festival.field.startDate' | translate }}:</label>
                <input formControlName="festivalStartDate" id="add-festival-start-date" name="add-festival-start-date" type="date" />
            </div>
            <div class="festival-form-input">
                <label for="add-festival-end-date">{{ 'festival.field.endDate' | translate }}:</label>
                <input formControlName="festivalEndDate" id="add-festival-end-date" name="add-festival-end-date" type="date" />
            </div>
            <div class="btn-container">
                <button class="btn-primary" id="btn-save" type="submit">
                    <mat-icon>save</mat-icon>
                    {{ 'festival.button.save' | translate }}
                </button>
                <button class="btn-primary" id="btn-cancel" type="button" (click)="onCancel()">
                    <mat-icon>cancel</mat-icon>
                    {{ 'festival.button.cancel' | translate }}
                </button>
            </div>
        </form>
    </div>
</div>
